<div *transloco="let t; prefix: 'company'">
  <app-office-list
    [offices]="offices"
    [loading]="loading"
    [columns]="companyListColumns"
    [globalFilterFields]="['companyName', 'countryCode', 'cityName', 'officeName', 'projects']"
    headerKey="company.list.header"
    [showEdit]="true"
    [showCreate]="true"
    (edit)="editCompany($event)"
    (create)="navigateToCreate()"
  ></app-office-list>
</div>
